import React, { Fragment, useState } from "react";
import { Motion, spring } from "react-motion";
import world from "./Static/world-110m.json";
import { Button } from "reactstrap";

import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
  Markers,
  Marker,
} from "react-simple-maps";

const ActivityField = (offices_info) => {
  let offices = [];

  if (offices_info.offices?.length > 0) {
    for (const o of offices_info.offices) {
      offices.push(JSON.parse(o));
    }
  }

  const cities = offices;
  // const cities = [
  //   { name: "Zurich", coordinates: [8.5417, 47.3769] },
  //   { name: "Singapore", coordinates: [103.8198, 1.3521] },
  //   { name: "San Francisco", coordinates: [-122.4194, 37.7749] },
  // ];

  const [center, setCenter] = useState([0, 20]);
  const [zoom, setZoom] = useState(1);

  const handleZoomIn = () => {
    setZoom(zoom * 2);
  };

  const handleZoomOut = () => {
    setZoom(zoom / 2);
  };

  const handleCityClick = (city) => {
    setZoom(2);
    setCenter(city.coordinates);
  };

  const handleReset = () => {
    setZoom(1);
    setCenter([0, 20]);
  };

  return (
    <div>
      <Fragment>
        <div>
          <div className="text-center mb-2 mt-3">
            <Button color="primary" className="mr-1" onClick={handleZoomIn}>
              {"Zoom in"}
            </Button>
            <Button color="primary" className="mr-2" onClick={handleZoomOut}>
              {"Zoom out"}
            </Button>
            <Button color="secondary" onClick={handleReset}>
              {"Reset"}
            </Button>
          </div>
          <Motion
            defaultStyle={{
              zoom: 1,
              x: 0,
              y: 20,
            }}
            style={{
              zoom: spring(zoom, { stiffness: 210, damping: 20 }),
              x: spring(center[0], { stiffness: 210, damping: 20 }),
              y: spring(center[1], { stiffness: 210, damping: 20 }),
            }}
          >
            {({ zoom, x, y }) => (
              <ComposableMap
                projectionConfig={{ scale: 205 }}
                width={980}
                height={551}
                style={{
                  width: "100%",
                  height: "auto",
                }}
              >
                <ZoomableGroup center={[x, y]} zoom={zoom}>
                  <Geographies geography={world}>
                    {(geographies, projection) =>
                      geographies.map(
                        (geography, i) =>
                          geography.id !== "010" && (
                            <Geography
                              key={i}
                              geography={geography}
                              projection={projection}
                              style={{
                                default: {
                                  fill: "#e9ecef",
                                  stroke: "#adb5bd",
                                  strokeWidth: 0.5,
                                  outline: "none",
                                },
                                hover: {
                                  fill: "#CFD8DC",
                                  // stroke: "#adb5bd",
                                  // strokeWidth: 0.5,
                                  outline: "none",
                                },
                                pressed: {
                                  fill: "#3f6ad8",
                                  // stroke: "#adb5bd",
                                  // strokeWidth: 0.5,
                                  outline: "none",
                                },
                              }}
                            />
                          )
                      )
                    }
                  </Geographies>
                  <Markers>
                    {cities.map((city, i) => (
                      <Marker key={i} marker={city} onClick={handleCityClick}>
                        <circle
                          cx={0}
                          cy={0}
                          r={8}
                          fill="#3f6ad8"
                          // stroke="#DF3702"
                        />
                      </Marker>
                    ))}
                  </Markers>
                </ZoomableGroup>
              </ComposableMap>
            )}
          </Motion>
        </div>
      </Fragment>
    </div>
  );
};

export default ActivityField;
